import React from 'react';
import { getURLParamsFromLocation } from 'common/utils/location';
import { RouteComponentProps } from 'react-router-dom';
import Logger from 'common/utils/logger';

export const CallbackPage = React.memo((props: RouteComponentProps) => {
  const urlQueryParams = getURLParamsFromLocation(props.location);
  const destinationUrl = urlQueryParams.get('state');
  const error = urlQueryParams.get('error');

  if (error) {
    props.history.push({
      pathname: '/error/',
      search: urlQueryParams.toString(),
    });
    return null;
  }

  if (destinationUrl) {
    urlQueryParams.delete('state');

    const separator = destinationUrl.includes('?') ? '&' : '?';
    const finalDestination = `${destinationUrl + separator + urlQueryParams.toString()}`;

    Logger.debug('callback page redirection', { destination: finalDestination });

    window.location.replace(finalDestination);
  } else {
    window.location.replace('/');
  }

  return null;
});
